import './App.css';
import Sidebar from './components/sidebar/Sidebar';
import Home from './components/home/Home';
import About from './components/about/About';
import Education from './components/education/Education';
import Portfolio from './components/portfolio/Portfolio';
import Skills from './components/skills/Skills';
import Contact from './components/contact/Contact';
import useLocalStorage from 'use-local-storage'
import { useEffect } from 'react';
import Switch from './switch';
function App() {
    const defaultDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const [theme, setTheme] = useLocalStorage('theme', defaultDark ? 'dark' : 'light');
    useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);
    const switchTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
    }

    return (
        <div className="app" data-theme={theme}>
            <Switch theme={theme} />
            <Sidebar theme={theme} switchTheme={switchTheme} />
            <main className='main'>
                <clockCursor/>
                <Home />
                <About />
                <Education />
                <Skills/>
                
                <Portfolio />
                
                
     
                <Contact theme={theme} />
            </main>
        </div>
    );
}

export default App;
